import { Dispatch } from 'redux';
import {
    requestReportRequest,
    requestReportSuccess,
    requestReportFailure,
    checkReportSuccess,
    checkReportFailure,
    cleanLinzeSalesReport as cleanReducer
} from '../reducers/linzeSalesReport';
import { axiosClient } from '../config/axios';
import { api } from '../config/api';
import { unauthorized } from '../reducers/unauthorized';
import { GetState } from '../config/store';

const REPORT_PATH = `${api.reports}/publications/reports/linze-sales`;

export const requestLinzeSalesReport = (dateFrom?: string, dateTo?: string, deleted?: string) =>
    (dispatch: Dispatch, getState: GetState) => _requestReport(dateFrom, dateTo, deleted, dispatch, getState);

const _requestReport = async (dateFrom: string | undefined, dateTo: string | undefined, deleted: string | undefined, dispatch: Dispatch, getState: GetState) => {
    try {
        dispatch({ type: requestReportRequest });

        const params: Record<string, string> = {};
        if (dateFrom) params.dateFrom = dateFrom;
        if (dateTo) params.dateTo = dateTo;
        if (deleted) params.deleted = deleted;

        const response = await axiosClient.post(REPORT_PATH, undefined, { params });
        const job = response.data?.data;

        dispatch({ type: requestReportSuccess, payload: job });
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        if (errorResponse?.statusCode === 403 || errorResponse?.statusCode === 401 || error?.response?.status === 403 || error?.response?.status === 401) {
            dispatch({ type: unauthorized });
            return;
        }
        dispatch({ type: requestReportFailure });
    }
};

export const checkLinzeSalesReport = (jobId: string) => (dispatch: Dispatch, getState: GetState) => _checkReport(jobId, dispatch, getState);
const _checkReport = async (jobId: string, dispatch: Dispatch, getState: GetState) => {
    try {
        const response = await axiosClient.get(`${REPORT_PATH}/${jobId}`);
        const job = response.data?.data;

        dispatch({ type: checkReportSuccess, payload: job });
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        if (errorResponse?.statusCode === 403 || errorResponse?.statusCode === 401 || error?.response?.status === 403 || error?.response?.status === 401) {
            dispatch({ type: unauthorized });
            return;
        }
        dispatch({ type: checkReportFailure });
    }
};

export const cleanLinzeSalesReport = () => (dispatch: Dispatch) => dispatch({ type: cleanReducer });
